import React from "react";

import { admin_cse } from "@/config/roles";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { getACPStatus } from "@/features/acp/helpers/program-status";
import { getLatestACPConsent } from "@/features/acp/helpers/latest-consent";
import { isAuthorized } from "@/redux/actions/auth";
import type { PatientConsent } from "@/core/types";

import { OptOutButton } from "./OptOutButton";
import { SectionDetailList } from "./SectionDetailList";

type MemberProfileACPSectionProps = {
  consents: PatientConsent[];
  insuranceCarrier: string;
};

export function MemberProfileACPSection({
  consents,
  insuranceCarrier,
}: MemberProfileACPSectionProps) {
  const latestACPConsent = getLatestACPConsent(consents);
  const { consentResponse, entityId, responseGivenByName, sortKey } = latestACPConsent || {};
  const consentStatus = getACPStatus({ consentResponse, insuranceCarrier });
  const isCSE = isAuthorized(admin_cse);

  return (
    <DashboardCard2
      Actions={
        consentStatus === "OPTED_IN" &&
        isCSE && (
          <OptOutButton patientId={entityId} patientName={responseGivenByName} sortKey={sortKey} />
        )
      }
      title="Advanced Care Program Status"
    >
      <SectionDetailList consent={latestACPConsent} consentStatus={consentStatus} />
    </DashboardCard2>
  );
}
